import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../../components/icon';
var IconFilterAlt = React.forwardRef(function (props, ref) {
  return React.createElement(Icon, _extends({}, props, {
    content: {
      "16": {
        "height": 16,
        "width": 16,
        "source": "<path d=\"M14 1H2a1 1 0 0 0-.89.54 1 1 0 0 0 .07 1L6 9.55V14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9.55l4.82-7a1 1 0 0 0 .07-1A1 1 0 0 0 14 1zM8 8.92 3.91 3h8.18z\"></path>"
      },
      "24": {
        "height": 24,
        "width": 24,
        "source": "<path d=\"M21.89 2.55A1 1 0 0 0 21 2H3a1 1 0 0 0-.89.55A1 1 0 0 0 2.2 3.6L10 14.09V21a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6.91L21.8 3.6a1 1 0 0 0 .09-1.05zM12 13.43 5 4h14z\"></path>"
      }
    },
    ref: ref
  }));
});
IconFilterAlt.displayName = 'IconFilterAlt';
IconFilterAlt.defaultProps = {
  size: 16
};
export default IconFilterAlt;